export default __webpack_public_path__ + "static/media/AcornMallCarpark_42.5ac3e0f7.png";